import type React from "react";
import {memo, useMemo} from "react";

import SelectGeneric from "../SelectGeneric";

export type SelectedMinuteOption = {
    label: string;
    value: number;
};

export type Props = {
    className?: string;
    minutes?: number;
    isDisabled?: boolean;
    onChange: (value: number) => void;
};

const SelectMinute: React.FC<Props> = ({className, minutes, isDisabled, onChange}) => {
    const options = useMemo(() => {
        const opts: SelectedMinuteOption[] = [];
        for (let i = 0; i < 60; i += 1) {
            // Pad single digit numbers with leading zero
            const label = i.toString().padStart(2, "0");
            opts.push({
                label,
                value: i
            });
        }
        return opts;
    }, []);

    // Get only the minutes portion using modulo
    const selectedMinuteValue = minutes !== undefined ? minutes % 60 : undefined;

    return (
        <SelectGeneric
            className={className}
            isDisabled={isDisabled}
            options={options}
            placeholder="Select minute..."
            testID="select-minute"
            value={selectedMinuteValue}
            onChange={onChange}
        />
    );
};

export default memo(SelectMinute);
